/** The slot unlock board's modes (see `widgets/unlock/SlotUnlockBoard`). */
export type SlotUnlockMode = 'offer' | 'unlock' | 'short' | 'downloading' | 'ready' | 'none';

/**
 * Which board to show for a slot: its price (null when the tile isn't a
 * slot), the player's gems, whether it was offered unasked, and how its
 * download stands once bought. An offer the player can no longer afford
 * shows as a tapped slot would: how many more gems it needs.
 */
export function slotUnlockMode(input: {
  price: number | null;
  gems: number;
  offer: boolean;
  download: 'idle' | 'downloading' | 'ready';
}): SlotUnlockMode {
  if (input.price === null) return 'none';
  if (input.download === 'downloading') return 'downloading';
  if (input.download === 'ready') return 'ready';
  if (input.gems < input.price) return 'short';
  return input.offer ? 'offer' : 'unlock';
}
